import { render, staticRenderFns } from "./SetDelivery.vue?vue&type=template&id=41b15364&lang=pug&"
import script from "./SetDelivery.vue?vue&type=script&lang=js&"
export * from "./SetDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports